import { RouteConfig } from 'vue-router';

const RouteNames = {
  Login: 'Login',
  ForgotPassword: 'ForgotPassword',
  ResetPassword: 'ResetPassword',
  Register: 'Register',
  ConfirmEmail: 'ConfirmEmail',
  AcceptTermsConditions: 'AcceptTermsConditions',
  Dashboard: 'Dashboard',
  ManageUsers: 'ManageUsers',
  ManageRoles: 'ManageRoles',
  ManageEmails: 'ManageEmails',
  ChangePassword: 'ChangePassword',
  EditProfile: 'EditProfile',
  InformationalVideos: 'InformationalVideos',
  ManageVehicles: 'My RV',
  ManageVehicleUsers: 'ManageVehicleUsers',
  Notifications: 'Notifications',
  NotificationDetails: 'NotificationDetails',
  RegisterVin: 'RegisterVin',
  ResubmitRegisterVin: 'ResubmitRegisterVin',
  DealerLocator: 'DealerLocator',
  UnitInformation: 'UnitInformation',
  OwnersManual: 'OwnersManual',
  SplashScreen: 'SplashScreen',
  Support: 'Support',
  FAQ: 'FAQ',
  Checklists: 'Checklists',
  CompanyToggle: 'CompanyToggle',
  PdfViewer: 'PdfViewer',
  PendingRVs: 'PendingRVs',
  BlogPosts: 'BlogPosts',
  BlogPostDetails: 'BlogPostDetails',
  PodCasts: 'PodCasts'
};

const routes: RouteConfig[] = [
  {
    path: '/login',
    name: RouteNames.Login,
    component: () => import('pages/Login.vue')
  },
  {
    path: '/forgot-password',
    name: RouteNames.ForgotPassword,
    component: () => import('pages/account/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    name: RouteNames.ResetPassword,
    component: () => import('pages/account/ResetPassword.vue')
  },
  {
    path: '/register',
    name: RouteNames.Register,
    component: () => import('pages/account/Register.vue')
  },
  {
    path: '/confirm-email',
    name: RouteNames.ConfirmEmail,
    component: () => import('pages/account/ConfirmEmail.vue')
  },
  {
    path: '/accept-terms-conditions',
    name: RouteNames.AcceptTermsConditions,
    component: () => import('pages/account/AcceptTermsAndConditions.vue')
  },
  {
    path: '/welcome',
    name: RouteNames.SplashScreen,
    component: () => import('src/pages/consumer/Welcome.vue')
  },
  {
    path: '/_system/setcompany/:companyType',
    name: RouteNames.CompanyToggle,
    component: () => import('pages/consumer/CompanyToggle.vue'),
    props: true
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: RouteNames.Dashboard, component: () => import('src/pages/Dashboard.vue') },
      {
        path: '/admin/manage-users',
        name: RouteNames.ManageUsers,
        component: () => import('pages/admin/ManageUsers.vue')
      },
      {
        path: '/admin/manage-roles',
        name: RouteNames.ManageRoles,
        component: () => import('pages/admin/ManageRoles.vue')
      },
      {
        path: '/admin/manage-emails',
        name: RouteNames.ManageEmails,
        component: () => import('pages/admin/ManageEmails.vue')
      },
      {
        path: '/account/change-password',
        name: RouteNames.ChangePassword,
        component: () => import('pages/account/ChangePassword.vue')
      },
      {
        path: '/account/edit-profile',
        name: RouteNames.EditProfile,
        component: () => import('pages/account/EditProfile.vue')
      },
      { path: '/my-rv', name: RouteNames.ManageVehicles, component: () => import('pages/consumer/ManageVehicles.vue') },
      { path: '/my-rv/register-vin', name: RouteNames.RegisterVin, component: () => import('pages/consumer/RegisterVin.vue')},
      { path: '/my-rv/resubmit-register-vin/:vinRegistrationUid', name: RouteNames.ResubmitRegisterVin, component: () => import('pages/consumer/RegisterVin.vue'), props: true },
      { path: '/my-rv/:vinUid/users', name: RouteNames.ManageVehicleUsers, component: () => import('pages/consumer/ManageVehicleUsers.vue'), props: true },
      { path: '/my-rv/:vinUid/service-information', name: RouteNames.UnitInformation, component: () => import('pages/consumer/ServiceInformation.vue'), props: true },
      { path: '/dealer-locator', name: RouteNames.DealerLocator, component: () => import('pages/consumer/DealerLocator.vue') },
      { path: '/informational-videos', name: RouteNames.InformationalVideos, component: () => import('pages/consumer/InformationalVideos.vue') },
      { path: '/faq', name: RouteNames.FAQ, component: () => import('pages/consumer/FAQ.vue') },
      { path: '/checklists', name: RouteNames.Checklists, component: () => import('pages/consumer/Checklists.vue') },
      {
        path: '/pdfviewer',
        name: RouteNames.PdfViewer,
        component: () => import('pages/consumer/PdfViewer.vue'),
        props: true
      },
      { path: '/pending-rvs', name: RouteNames.PendingRVs, component: () => import('pages/consumer/PendingRVs.vue') },
      {
        path: '/notifications',
        name: RouteNames.Notifications,
        component: () => import('pages/consumer/Notifications.vue')
      },
      {
        path: '/notification-details/:notificationUid',
        name: RouteNames.NotificationDetails,
        component: () => import('pages/consumer/NotificationDetails.vue'),
        props: true
      },
      { path: '/support', name: RouteNames.Support, component: () => import('pages/consumer/Support.vue') },
      {
        path: '/campfire-stories',
        name: RouteNames.BlogPosts,
        component: () => import('src/pages/consumer/BlogPosts.vue')
      },
      {
        path: '/campfire-stories/:postId-:slug',
        name: RouteNames.BlogPostDetails,
        component: () => import('src/pages/consumer/BlogPostDetails.vue'),
        props: true
      },
      { path: '/podcasts', name: RouteNames.PodCasts, component: () => import('src/pages/consumer/Podcasts.vue') }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
];

export { routes, RouteNames };
